import axios from 'axios'
import { notification } from 'ant-design-vue';
import { getToken, removeToken } from '@/utils/auth';


// dev 
export const baseUrl = process.env.VUE_APP_API_BASE_URL


// 创建axios的对象
const instance = axios.create({
    baseURL: baseUrl,  //配置固定域名
    timeout: 300000
    // timeout: 30000
})

// 请求拦截
// 所有的网络请求都会走这个方法,可以在请求添加自定义内容
instance.interceptors.request.use(
    function (config) {
        config.headers.Authorization = getToken() // 请求头添加token值
        return config
    },
    function (err) {
        return Promise.request(err)
    }
)

// 响应拦截
// 此处可以根据服务器返回的状态码做相应的数据
instance.interceptors.response.use(
    function (response) {
        const res = response
        // console.log('axios-res', res.config.url, res.data)
        if (res.data.status === 500) {
            notification["error"]({ message: "提醒", description: res.data.message });
        } else if (res.data.status === 403) {
            removeToken()
            location.href = './#/login'
        }
        return res.data
    },
    function (err) {
        console.log(err)
        return { success: false }
    }
)

// 封装get和post请求
export function get(url, params) {
    return instance.get(url, { params })
}

export function post(url, data) {
    return instance.post(url, data)
}

export default instance;